import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 11c0 2.21 -2.239 4 -5 4s-5 -1.79 -5 -4a8 8 0 1 0 16 0a3 3 0 0 0 -6 0","key":"svg-0"}],["path",{"d":"M16 8c0 -2 2 -4 4 -4","key":"svg-1"}]]

/**
 * IconPepper
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcGVwcGVyIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMyAxMWMwIDIuMjEgLTIuMjM5IDQgLTUgNHMtNSAtMS43OSAtNSAtNGE4IDggMCAxIDAgMTYgMGEzIDMgMCAwIDAgLTYgMCIgLz4KICA8cGF0aCBkPSJNMTYgOGMwIC0yIDIgLTQgNCAtNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/pepper
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPepper = createReactComponent('outline', 'pepper', 'Pepper', __iconNode);

export default IconPepper;